import { useState, useCallback } from "react";
import { UseSavingModalsReturn } from "./types";

/**
 * Custom hook to manage all modal states for the SavingPage
 * Handles:
 * - Delete saving modal
 * - Delete progress modal
 * - Activate/Deactivate modal
 */
export const useSavingModals = (): UseSavingModalsReturn => {
  const [deleteModal, setDeleteModal] = useState(false);
  const [progressDeleteModal, setProgressDeleteModal] = useState(false);
  const [activateModal, setActivateModal] = useState(false);

  const openDeleteModal = useCallback(() => setDeleteModal(true), []);
  const closeDeleteModal = useCallback(() => setDeleteModal(false), []);

  const openProgressDeleteModal = useCallback(
    () => setProgressDeleteModal(true),
    [],
  );
  const closeProgressDeleteModal = useCallback(
    () => setProgressDeleteModal(false),
    [],
  );

  const openActivateModal = useCallback(() => setActivateModal(true), []);
  const closeActivateModal = useCallback(() => setActivateModal(false), []);

  return {
    deleteModal,
    progressDeleteModal,
    activateModal,
    openDeleteModal,
    closeDeleteModal,
    openProgressDeleteModal,
    closeProgressDeleteModal,
    openActivateModal,
    closeActivateModal,
  };
};
